export const STRIPE_PUBLISHABLE_KEY_MISSING_MESSAGE =
	"Stripe publishable key is not configured. Set NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY in the environment.";

export function getStripePublishableKeyOrNull(
	...candidates: Array<string | null | undefined>
): string | null {
	for (const candidate of candidates) {
		const trimmed = candidate?.trim();
		if (trimmed) {
			return trimmed;
		}
	}
	return null;
}

export function resolveStripePublishableKey(
	...candidates: Array<string | null | undefined>
): string {
	const key = getStripePublishableKeyOrNull(...candidates);
	if (!key) {
		throw new Error(STRIPE_PUBLISHABLE_KEY_MISSING_MESSAGE);
	}
	return key;
}
